module.exports = __webpack_public_path__ + "static/img-community.d789b58d.jpg";